var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"octadesk-chat-message-item"},[_c('span',{staticClass:"octadesk-app-join-room"},[_c('span',[_vm._v("\n      "+_vm._s(_vm.$t('conversation.closed', {
          name: _vm.chat.closed.user.displayName || _vm.chat.closed.user.name
        }))+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }